<template>
  <main class="container container-choose-route d-flex flex-column align-items-center">
    <CustomerForgotPasswordComponent></CustomerForgotPasswordComponent>
  </main>
</template>

<script lang="ts">

import axios from "axios";
import apiService from "../../services/apiService";
import {useStore} from "vuex";

// @ts-ignore
import CustomerForgotPasswordComponent from "../../components/CustomerForgotPassword/CustomerForgotPasswordComponent";
import {defineComponent} from "vue";

export default defineComponent({
  name: "ForgotPasswordPage",
  components: {
    CustomerForgotPasswordComponent,
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {}
  },
  methods: {},
  created() {
    axios.get(apiService.pageForgotPasswordPageEndpoint())
        .then((response) => {})
        .catch(error => console.error(error));
  }
});
</script>